import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', function (value) {
  if (!value) return ''
  return moment(value).format('DD/MM/YYYY HH:mm:ss')
})

Vue.filter('formatUTCDate', function (value) {
  if (!value) return ''
  return moment(value).utc().format('DD/MM/YYYY HH:mm:ss')
})

Vue.filter('formatUnix', function (value) {
  if (!value) return ''
  return moment.unix(value).format('DD/MM/YYYY HH:mm:ss')
})

Vue.filter('formatDateNotification', function (value) {
  if (!value) return ''
  if (moment().diff(moment.unix(value), 'days') > 5) return moment.unix(value).format('DD/MM/YYYY HH:mm:ss')
  return moment.unix(value).locale('es').fromNow()
})
